module.exports = __webpack_public_path__ + "img/mitaofei.aca46879.png";